export default function sidebars(state = [], action)
{
    switch (action.type){
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/sidebars.js